module.exports = __webpack_public_path__ + "static/media/size_9_on.5569a639.svg";